/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientLegalInformationRequest
 */
export interface ClientLegalInformationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientLegalInformationRequest
     */
    companyIds?: Array<string>;
    /**
     * Optional provider to use for fetching or refreshing legal information
     * @type {string}
     * @memberof ClientLegalInformationRequest
     */
    provider?: ClientLegalInformationRequestProviderEnum;
}


/**
 * @export
 */
export const ClientLegalInformationRequestProviderEnum = {
    NorthData: 'NORTH_DATA',
    Pappers: 'PAPPERS',
    Inpi: 'INPI'
} as const;
export type ClientLegalInformationRequestProviderEnum = typeof ClientLegalInformationRequestProviderEnum[keyof typeof ClientLegalInformationRequestProviderEnum];


/**
 * Check if a given object implements the ClientLegalInformationRequest interface.
 */
export function instanceOfClientLegalInformationRequest(value: object): value is ClientLegalInformationRequest {
    return true;
}

export function ClientLegalInformationRequestFromJSON(json: any): ClientLegalInformationRequest {
    return ClientLegalInformationRequestFromJSONTyped(json, false);
}

export function ClientLegalInformationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientLegalInformationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyIds': json['companyIds'] == null ? undefined : json['companyIds'],
        'provider': json['provider'] == null ? undefined : json['provider'],
    };
}

export function ClientLegalInformationRequestToJSON(value?: ClientLegalInformationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyIds': value['companyIds'],
        'provider': value['provider'],
    };
}

